export class BaseResponseDto<T> {
  public ErrorCode!: number;
  public ErrorMessage!: string;
  public Data!: T;
}
